import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const container = css`
  @media (max-width: ${dimensions.phoneLargeMax}) {
    overflow-y: visible;
  }
`;
